/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 *  Backend configurations for transmitting data to endpoints
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import {getScriptVariableStore , getPluginFactory, GetProperty} from "./bootstrap_web_ext";
import {ModuleManager , globalEngine} from "./Init";
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";
import {isFirstFileVersionGreater} from "./common";

// #ENDIF WebPack
function createEmitter(profileName, profile)
{
    function _retrieveStoredPlugin(storedName, pluginName)
    {
        // retrieve a plugin from the variable store, otherwise instantiate one and put it into the store
        var plugin = getScriptVariableStore().Get(storedName);
        if (plugin)
        {
            return plugin;
        }

        try
        {
            plugin = getPluginFactory().Create(pluginName);
        }
        catch (e)
        {
            logError("Failed to create plugin: '" + pluginName + "'");
        }

        try
        {
            getScriptVariableStore().Set(storedName, plugin);
        }
        catch (e)
        {
            logError("Failed to set plugin '" + pluginName + "' in store as '" + storedName + "'");
        }

        return plugin;
    }

    try {
        var emitter =
        {
            "configure": function (profileName, profile)
            {
                this.profileName = profileName;
                this.profile = profile;
                this.transportName = profile.transport;
                this.transportConfiguration = profile.transport_config;
                this.dataSetNames = profile.datasets;
                this.enableRules = profile.enableRules;
                this.throttleRule = profile.throttleRule;
                this.throttleMultiplier = profile.throttleMultiplier;
                this.maxDimensionLength = profile.maxDimensionLength;
            },
            "send": function (outbound)
            {
                try
                {

                    if (!this._isEnabled())
                    {
                        logInformation('_isEnabled() returned false. Will not send data to ' + this.transportName);
                        return false;
                    }

                    outbound = this._sanitize(outbound);

                    //Unsupported versions
                    //csp transport version 1
                    if('csp' == this.transportName && "1" == this._getPlugin(this.transportName).GetVersion())
                    {
                        return false;
                    }
                    
                    if(!this.initialized)
                    {
                        var mappingDictionary = ModuleManager.getSingleton("mappings").getProfileTableStr(this.profile.dictionary);
                        this._getPlugin(this.transportName).Initialize(this.transportName, mappingDictionary, JSON.stringify(this.transportConfiguration));
                        this.initialized = true;
                    }
                    logDebug("Emit outbound data: " + JSON.stringify(outbound));
                    return this._getPlugin().Send(JSON.stringify(outbound));
                }
                catch (e)
                {
                    logError("Failed to Emit data: exception = '" + e.message + "'");
                }
            },
            "_isEnabled": function ()
            {
                try
                {
                    // If there are no rules, it's enabled by default
                    if (null == this.enableRules)
                    {
                        return true;
                    }
                    
                    if ('data_collector' == this.enableRules.sourceType)
                    {
                        var data_collector = ModuleManager.getSingleton("data_collector");
                        var value = data_collector.get(this.enableRules.name);
                        var rules = ModuleManager.getSingleton("rules");
                        return rules.evaluate(value, this.enableRules.rule);
                    }
                    
                    logError('_isEnabled: unexpected enableRules.sourceType. sourceType ' + this.enableRules.sourceType);
                    return false;
                }
                catch (e)
                {
                    logError('_isEnabled: ' + e.message);
                    return false;
                }
            },
            "_pluginFactories" :
            {
                 "da": {
                    "Create": function (name) {
                        //GetProperty defaults to empty, so that sdk versions without
                        //"Analytics.SDK.Version" property uses old da plugin
                        var sdkVer = GetProperty("Analytics.SDK.Version",""/*default*/);
                        logDebug("Tansport: " + name + " with SDK version: " + sdkVer);

                        if (isFirstFileVersionGreater("2,5,9999,9999",sdkVer)) {
                            return _retrieveStoredPlugin(name, "da");
                        }
                            
                        return ModuleManager.getSingleton("transport_da");
                    }
                },
                "ai": { "Create": function (name) { return ModuleManager.create("transport_ai"); } },
                "eh": { "Create": function (name) { return ModuleManager.create("transport_event_hub"); } },
                "ga": getPluginFactory(),
                "csp": getPluginFactory(),
                "ga_rest": { "Create": function (name) { return ModuleManager.create("transport_ga"); } },
                "msgbus" : { "Create": function (name) { return ModuleManager.getSingleton("transport_msgbus"); } }
            },
            "_getPlugin": function (name)
            {
                try
                {
                    if (!this._plugin)
                    {
                        logDebug('Trying to create transport plugin with name: ' + name);
                        var factory = this._pluginFactories[name];
                        if (!factory)
                        {
                            logDebug('using plugin factory');
                            // just-in-case: use the generic plugin factory
                            factory = getPluginFactory();
                        }
                        this._plugin = factory.Create(name);
                    }
                }
                catch (e)
                {
                    logError('_getPlugin: Exception caught with message '+ e.message);
                }
                return this._plugin;
            },
            "_sanitize": function (data) // NOTE: modifies 'data' in-place
            {
                // DIRTY HACK: REMOVE ME
                // TODO: REMOVE THIS AFTER RELEASING CONTENT 1.0
                // ALWAYS STRINGIFY THE DATA BEFORE SENDING TO AVOID THE KNOWN CRASH (see comment below)
                var escapecharacters = this.transportName.match('^ga');
                for (var entry in data)
                {
                    if(escapecharacters)
                    {
                        try
                        {
                            //Escape values, make sure nothing is double escaped
                            data[entry] = escape(unescape(data[entry])); 
                        }
                        catch(e)
                        {
                            // fallback to force everything to be a string
                            data[entry] = String(data[entry]);
                        }
                    }
                    else
                    {
                        data[entry] = String(data[entry]);
                    }

                    // truncate characters to limit
                    if ((this.maxDimensionLength != null) && !isNaN(this.maxDimensionLength) )
                    {
                        // if exceeds max, truncate and add "..." at the end
                        if (data[entry].length > this.maxDimensionLength)
                        {
                            data[entry] = data[entry].substring(0, this.maxDimensionLength - 3) + "...";
                        }
                    }

                }
                return data;
            },
            "_plugin": null,
            "_initialized": false
        }; // end 'emitter'

        //emitter.configure(profileName, profile);

        return emitter;
    }
    catch(e)
    {
        logError("Failed to create the '" + transportName + "' emitter: " + e.message);
    }
    return null;
}

// register with the factory function with ModuleManager
ModuleManager.registerFactory("emitter", createEmitter);
//export {createEmitter};
//globalEngine.FactoryMap["emitter"] =  createEmitter;
